(() => {
  'use strict';
  const dialog = document.querySelector('.cart-dialog');
  let menuOpen = false;
  function closeMenu() {
    const menuButton = document.querySelector('.menu-toggle');
    const menu = document.querySelector('#mobile-menu');
    menuOpen = false;
    if (menu) menu.hidden = true;
    menuButton?.setAttribute('aria-expanded', 'false');
    menuButton?.setAttribute('aria-label', 'Abrir menú');
    document.body.classList.remove('locked');
  }
  // Delegation keeps the menu working after Shopify replaces the header HTML.
  document.addEventListener('click', event => {
    const menuButton = event.target.closest('.menu-toggle');
    if (menuButton) {
      const menu = document.querySelector('#mobile-menu');
      if (!menu) return;
      menuOpen = !menuOpen;
      menu.hidden = !menuOpen;
      menuButton.setAttribute('aria-expanded', String(menuOpen));
      menuButton.setAttribute('aria-label', menuOpen ? 'Cerrar menú' : 'Abrir menú');
      document.body.classList.toggle('locked', menuOpen);
    }
    if (event.target.closest('.mobile-menu a')) closeMenu();
    if (event.target.closest('.cart-toggle')) {
      closeMenu();
      if (dialog) {
        dialog.showModal();
        document.body.classList.add('locked');
      }
    }
  });
  document.addEventListener('keydown', e => {
    const menuButton = document.querySelector('.menu-toggle');
    const menu = document.querySelector('#mobile-menu');
    if (e.key === 'Escape' && menuOpen) { closeMenu(); menuButton?.focus(); }
    if (e.key === 'Tab' && menuOpen) {
      if (!menuButton || !menu) { closeMenu(); return; }
      const focusables = [menuButton, ...menu.querySelectorAll('a')];
      const first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  const desktop = matchMedia('(min-width:761px)');
  desktop.addEventListener('change', e => { if(e.matches) closeMenu(); });
  document.querySelector('.cart-close')?.addEventListener('click', () => dialog?.close());
  document.querySelectorAll('[data-close-cart]').forEach(link => link.addEventListener('click', () => dialog?.close()));
  dialog?.addEventListener('close', () => document.body.classList.remove('locked'));
  dialog?.addEventListener('click', e => {
    const rect = dialog.getBoundingClientRect();
    if (e.target === dialog && (e.clientX < rect.left || e.clientX > rect.right)) dialog.close();
  });

  function initSections(root = document) {
  root.querySelectorAll('[data-flip-card]').forEach(card => {
    if (card.dataset.flipReady) return;
    const button = card.querySelector('.manifesto-flip-toggle');
    const front = card.querySelector('[data-flip-front]');
    const back = card.querySelector('[data-flip-back]');
    const frontLabel = button.querySelector('[data-flip-label-front]');
    const backLabel = button.querySelector('[data-flip-label-back]');
    function setFlipped(flipped) {
      card.dataset.flipped = String(flipped);
      button.setAttribute('aria-expanded', String(flipped));
      front.setAttribute('aria-hidden', String(flipped));
      back.setAttribute('aria-hidden', String(!flipped));
      front.inert = flipped;
      back.inert = !flipped;
      frontLabel.hidden = flipped;
      backLabel.hidden = !flipped;
    }
    setFlipped(card.dataset.editorShowBack === 'true');
    card.dataset.flipReady = 'true';
    button.hidden = false;
    button.addEventListener('click', () => setFlipped(card.dataset.flipped !== 'true'));
    button.addEventListener('keydown', event => {
      if (event.key === 'Escape' && card.dataset.flipped === 'true') {
        event.preventDefault();
        setFlipped(false);
      }
    });
  });
  root.querySelectorAll('.product-gallery').forEach(gallery => {
    if (gallery.dataset.glufReady) return;
    gallery.dataset.glufReady = 'true';
    const image = gallery.querySelector('.product-image');
    const thumbs = [...gallery.querySelectorAll('.gallery-thumb')];
    thumbs.forEach((button, index) => button.addEventListener('click', () => {
      image.removeAttribute('srcset');
      image.src = button.dataset.image;
      image.alt = button.dataset.alt;
      image.classList.toggle('photo-mode', index > 0 && !gallery.hasAttribute('data-product-gallery'));
      gallery.classList.toggle('dark-photo', index === 1 && !gallery.hasAttribute('data-product-gallery'));
      gallery.querySelector('.gallery-index').textContent = `${String(index + 1).padStart(2, '0')} / ${String(thumbs.length).padStart(2, '0')}`;
      thumbs.forEach(thumb => {
        thumb.setAttribute('aria-pressed', String(thumb === button));
        thumb.classList.toggle('active', thumb === button);
      });
    }));
  });

  const stages = [
    { title: 'Todo empieza\ncon una cadena.', body: 'Las proteínas están formadas por aminoácidos unidos entre sí. Podemos imaginarlas como una cadena de eslabones.' },
    { title: 'La enzima actúa\nsobre los enlaces.', body: 'En la proteólisis, las enzimas catalizan la ruptura de determinados enlaces de la cadena de una proteína.' },
    { title: 'La misma cadena.\nFragmentos más pequeños.', body: 'El proceso da lugar a fragmentos de menor tamaño. Eso es la proteólisis: dividir una proteína en partes más pequeñas.' }
  ];
  root.querySelectorAll('.science-interactive').forEach(science => {
    if (science.dataset.glufReady) return;
    science.dataset.glufReady = 'true';
    const tabs = [...science.querySelectorAll('[role="tab"]')];
    function select(index) {
      science.dataset.stage = String(index);
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      science.querySelector('[role="tabpanel"]').setAttribute('aria-labelledby', tabs[index].id);
      science.querySelector('.stage-number').textContent = `[ 0${index + 1} ]`;
      const title = science.querySelector('.science-explanation h3');
      title.replaceChildren();
      (tabs[index].dataset.title || stages[index].title).split('\n').forEach((line, i) => { if (i) title.append(document.createElement('br')); title.append(document.createTextNode(line)); });
      science.querySelector('.science-explanation p').textContent = tabs[index].dataset.description || stages[index].body;
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', e => {
        let next;
        if (e.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (e.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { e.preventDefault(); select(next); tabs[next].focus(); }
      });
    });
    if (tabs[0]?.dataset.title) select(Number(science.dataset.editorStage || 0));
  });
  }
  initSections();
  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('.site-header')) closeMenu();
    initSections(event.target);
  });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('.site-header')) closeMenu();
  });
  document.addEventListener('shopify:block:select', event => {
    const detail = event.target.closest('details');
    if (detail) detail.open = true;
  });
})();
